/**
 * 输出信息堆栈，成员格式
 * {
 *    message: '',
 *    count: 0,
 *    startTime: new Date().getTime(),
 *    lastTime: new Date().getTime()
 * }
 */
export let logStack = [];

const TIME_INTERVAL = 1000;

const throttleLog = fn => {
  return (message, ...restArgs) => {
    const stackMessage = (Array.isArray(message)
      ? message
      : [message, ...restArgs]
    ).join('-');

    let stackItem = logStack.find(item => item.message === stackMessage);

    const currentTime = new Date().getTime();

    if (!stackItem) {
      stackItem = {
        message: stackMessage,
        count: 1,
        startTime: currentTime,
        lastTime: currentTime
      };

      logStack.push(stackItem);

      fn(message, ...restArgs);

      // 清空所有已超出时间范围的日志栈成员
      logStack = logStack.filter(
        item => currentTime - item.lastTime < TIME_INTERVAL
      );

      return;
    }

    if (currentTime - stackItem.lastTime < TIME_INTERVAL) {
      stackItem.count++;
      stackItem.lastTime = currentTime;
    } else {
      stackItem.count = 1;
      stackItem.startTime = currentTime;
      stackItem.lastTime = currentTime;

      fn(message, ...restArgs);
    }
  };
};

/**
 * @public
 *
 * 输出文本到开发者工具
 * @param {*} message 文本信息
 * @param {*} restArgs 剩余参数
 */
export const log = throttleLog((message, ...restArgs) => {
  const logFn = console.error;
  let results = Array.isArray(message) ? message : [[message, ...restArgs]];

  logFn(
    '%c下方为来自 基础平台-xpc 异常提示 😊 ！',
    'background:#e05258;color: white'
  );
  Array.isArray(results[0])
    ? results.forEach(item => logFn(...item))
    : logFn(results);
  logFn(
    '%c以上为来自 基础平台-xpc 异常提示，欢迎指正反馈 👏 ！',
    'background:#e05258;color: white'
  );

  console.log();
});

/**
 * @public
 *
 * 废弃提醒
 */
export const deprecatedLog = (currentCom, oldVal, newVal, type) => {
  // 即将废弃的方法提示
  if (type === 'fn') {
    log([
      [
        ' 👮‍♀️ %c异常提示: 【%s】组件内部发送请求的【%s】方法即将废弃! 请使用【%s】自定义查询，若有疑问请咨询基础平台',
        'color: #e05258;font-size:14px',
        currentCom,
        oldVal.slice(6),
        newVal
      ]
    ]);
    // 即将废弃的属性提示
  } else if (type === 'prop') {
    log([
      [
        ' 👮‍♀️ %c异常提示: 【%s】组件内部属性【%s】即将废弃! 若有疑问请咨询基础平台',
        'color: #e05258',
        currentCom,
        oldVal
      ]
    ]);
    // 其他废弃提示
  } else {
    log([
      [
        ' 👮‍♀️ %c异常提示: %s 即将废弃! 若有疑问请咨询基础平台',
        'color: #e05258',
        oldVal
      ]
    ]);
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/xpc/log.js